import Box from '@mui/material/Box';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { GlobalPageSections } from '@/constants/analytics';
import { SITE_ROUTES } from '@/constants/global';
import { PageSection } from '@/lib/analytics/react-data-tracking';
import { useSwitchr } from '@/lib/switchr/switchr/client';
import { NAMESPACE_COMMON } from '@/translations/namespaces';

const MOBILE_BANNER_MIN_HEIGHT = 90;
const DESKTOP_BANNER_MIN_HEIGHT = 60;

const styles = {
  root: ({ breakpoints, palette }: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center' as const,
    backgroundColor: palette.warning.main,
    color: palette.white.main,
    minHeight: `${DESKTOP_BANNER_MIN_HEIGHT}px`,
    position: 'relative' as const,
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
      minHeight: `${MOBILE_BANNER_MIN_HEIGHT}px`,
    },
  }),
  button: ({ palette }: Theme) => ({
    margin: 1,
    minWidth: 25,
    borderColor: palette.white.main,
    color: palette.white.main,
    padding: '0 20px',
    '&:hover': {
      borderColor: palette.white.main,
    },
  }),
  text: {
    padding: 0.5,
  },
  link: ({ palette, typography }: Theme) => ({
    color: palette.white.main,
    fontWeight: typography.fontWeightBold,
    textDecoration: 'underline',
    '&:hover': {
      borderColor: palette.white.main,
    },
  }),
};

export const OutageBanner = () => {
  const router = useRouter();
  const path = router.pathname;
  const isContactPage = path === SITE_ROUTES.CONTACT_PAGE;
  const { checkGate } = useSwitchr();
  const { t } = useTranslation(NAMESPACE_COMMON);
  const hideDirectlyWidget = checkGate('contrib-5007-skip-directly-usage');

  if (hideDirectlyWidget && isContactPage) {
    return (
      <PageSection value={GlobalPageSections.outageBanner}>
        <Box sx={styles.root} data-testid="outage-banner">
          <Typography sx={styles.text} color="common.black" variant="body1">
            {t('contact_us_outage_banner')}
          </Typography>
          <Typography sx={styles.text} fontWeight={700} color="common.black" variant="body1">
            submit@shutterstock.com
          </Typography>
        </Box>
      </PageSection>
    );
  }

  return null;
};
